import { Component, HostListener, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MaxBrainAudience } from 'app/library/audience/models/audience.model';
import { AudienceService } from 'app/library/audience/services/audience.service';
import { MaxBrainExperience } from 'app/library/experience/models/experience.model';
import { ExperienceService } from 'app/library/experience/services/experience.service';
import { SidenavService } from '../../../services/sidenav.service';
import { IChoosenFilterInterface } from 'app/library/all-users/interfaces/choosen-filter.interface';

@Component({
    selector: 'app-experience-start',
    templateUrl: './experience-start.component.html',
    styleUrls: ['./experience-start.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ExperienceStartComponent implements OnInit {
    searchInput = new FormControl();
    experiences: MaxBrainExperience[] = [];
    audiences: MaxBrainAudience[] = [];
    isLoadingExperiences: boolean = true;

    screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    @HostListener('window:resize')
    onResize() {
        this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }

    constructor(private _router: Router, private _audienceService: AudienceService, private _sidenavService: SidenavService, private _experienceService: ExperienceService) {}

    async ngOnInit(): Promise<void> {
        this.experiences = await this.loadExperiences();
        this.isLoadingExperiences = false;

        this.audiences = this._audienceService.getAudiences() || [];
        if (!this.audiences.length) {
            await this._audienceService.fetchAudiences();
            this.audiences = this._audienceService.getAudiences();
        }
    }

    private async loadExperiences(): Promise<MaxBrainExperience[]> {
        let experiences = this._experienceService.getExperiences() || [];
        const hasIncompleteCounts = experiences.some((experience) => experience.memberCount == null || experience.widgetCount == null);

        if (!experiences.length || hasIncompleteCounts) {
            await this._experienceService.fetchExperiences();
            experiences = this._experienceService.getExperiences() || [];
        }

        return experiences;
    }

    toggleSidenav() {
        this._sidenavService.toggle();
    }

    onPreviewHomeScreen(experienceId: string) {
        const defaultAudienceId = this.audiences.find((audience) => !audience.parent).id;
        const preSelectedAudiences: IChoosenFilterInterface[] = JSON.parse(sessionStorage.getItem('growAudienceFilter'));
        const preSelectedAudienceIds = preSelectedAudiences?.map((audience) => audience.entity.id).toString();
        this._router.navigate([`admin/grow-home-preview/${experienceId}/${preSelectedAudienceIds || defaultAudienceId}`]);
    }
}
